import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "feather feather-upload-cloud"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("polyline", { points: "16 16 12 12 8 16" }, null, -1),
    _createElementVNode("line", {
      x1: "12",
      y1: "12",
      x2: "12",
      y2: "21"
    }, null, -1),
    _createElementVNode("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }, null, -1),
    _createElementVNode("polyline", { points: "16 16 12 12 8 16" }, null, -1)
  ]))]))
}
export default { render: render }